import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

const UNREAD_TRANSACTIONS_KEY: string = 'number of unread transactions';
@Injectable({
  providedIn: 'root',
})
export class UnreadTransactionsService {
  public unreadTransactionsCount = new Subject();

  public getUnreadTransactionsCount() {
    return JSON.parse(localStorage.getItem(UNREAD_TRANSACTIONS_KEY));
  }

  public setUnreadTransactionsCount(count: number) {
    this.unreadTransactionsCount.next(String(count));
    localStorage.setItem(UNREAD_TRANSACTIONS_KEY, String(count));
  }
}
